<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="filename"
  [nzFooter]="footer"
  nzWidth="80vw"
  (nzOnCancel)="close()">
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="loading">
      <div class="preview-body">
        <ng-container *ngIf="!loading && previewUrl">
          <img *ngIf="fileType === 'image'" [src]="previewUrl" class="preview-image" />
          <iframe *ngIf="fileType === 'pdf'" [src]="previewUrl" class="preview-iframe"></iframe>
          <div *ngIf="fileType === 'other'" class="preview-other">
            <i nz-icon nzType="file" nzTheme="outline" class="preview-file-icon"></i>
            <p>Preview not available. Please download the file.</p>
            <button nz-button nzType="primary" (click)="download()">
              <i nz-icon nzType="download"></i> Download
            </button>
          </div>
        </ng-container>
      </div>
    </nz-spin>
  </ng-container>
  <ng-template #footer>
    <button nz-button (click)="close()">Close</button>
    <button nz-button nzType="primary" [disabled]="!previewUrl || loading" (click)="download()">
      <i nz-icon nzType="download"></i> Download
    </button>
  </ng-template>
</nz-modal>
